import React,{Component} from "react"
import { Progress, Icon } from 'antd';

export default class Maintenance extends Component{

render(){
    return(
    <div className="maintenance">
       <div>
       <h1 className="spanner"><Icon type="setting" spin/></h1>
       <div className="content">
           
       <h1>Maintenace Mode</h1>
        <p>We're making lots of improvement and will get back soon!</p>
       </div>
       <Progress percent={80} status="active" />

      </div>
    </div>)
}
}